import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';

import samlInit from 'helpers/samlInit';

const styles = theme => {
  return {
    button: {
      fontSize: 14.6,
      fontWeight: 'bold',
      lineHeight: 1.1,
      letterSpacing: 1.25,
      marginBottom: theme.spacing(1),
      width: 265,
      height: 39,
      marginTop: theme.spacing(1),
    },
  };
};

class SamlButton extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    loginOptionResponse: PropTypes.object,
    color: PropTypes.string,
    additionalParams: PropTypes.object.isRequired,
  };

  samlSubmit = () => {
    samlInit(this.props.loginOptionResponse, this.props.additionalParams);
  };

  render() {
    const { classes, color, loginOptionResponse } = this.props;
    const buttonCopy = loginOptionResponse.loginOptions.samlButtonCopy || 'Use Company Login (SSO)';

    return (
      <Button className={classes.button} onClick={this.samlSubmit} variant="outlined" color={color}>
        {buttonCopy}
      </Button>
    );
  }
}

export default withStyles(styles)(SamlButton);
